<template>
    <div class="sf__vehicles__options">
        <div class="sf__vehicles__option" data-label="Year" :class="{ 'option-selected': selections.year != '' }">
            <select v-bind:class="{ 'selected': selections.year != '', 'errored': selections.year == '' && showError }" name="year" id="" v-model="selections.year" :disabled="dropdowns.year.length < 1">
                <option value="">{{ yearLabel || 'Select Year' }}</option>
                <option v-for="year in dropdowns.year" :key="year.key" :value="year.key">{{ year.value }}</option>
            </select>
            <svg class="sf__vehicles__select-icon" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false">
                <path d="M16.293 9.29297L12 13.586L7.70697 9.29297L6.29297 10.707L12 16.414L17.707 10.707L16.293 9.29297Z" :fill="dropdowns.year.length < 1 ? '#737373' : '#DE4527'"/>
            </svg>
        </div>

        <div class="sf__vehicles__option" data-label="Make" :class="{ 'option-selected': selections.make != '' }">
            <select v-bind:class="{ 'selected': selections.make != '', 'errored': selections.make == '' && showError }" name="make" id="" v-model="selections.make" :disabled="dropdowns.make.length < 1">
                <option value="">{{ makeLabel || 'Select Make' }}</option>
                <option v-for="make in dropdowns.make" :key="make.key" :value="make.key">{{ make.value }}</option>
                <option value="cant-find">{{ cantFindLabel || 'Can\'t find your vehicle?' }}</option>
            </select>
            <svg class="sf__vehicles__select-icon" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false">
                <path d="M16.293 9.29297L12 13.586L7.70697 9.29297L6.29297 10.707L12 16.414L17.707 10.707L16.293 9.29297Z" :fill="dropdowns.make.length < 1 ? '#737373' : '#DE4527'"/>
            </svg>
        </div>


        <div class="sf__vehicles__option" data-label="Model" :class="{ 'option-selected': selections.model != '' }">
            <select v-bind:class="{ 'selected': selections.model != '', 'errored': selections.model == '' && showError }" name="model" id="" v-model="selections.model" :disabled="dropdowns.model.length < 1">
                <option value="">{{ modelLabel || 'Select Model' }}</option>
                <option v-for="model in dropdowns.model" :key="model.key" :value="model.key">{{ model.value }}</option>
                <option value="cant-find">{{ cantFindLabel || 'Can\'t find your vehicle?' }}</option>
            </select>
            <svg class="sf__vehicles__select-icon" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false">
                <path d="M16.293 9.29297L12 13.586L7.70697 9.29297L6.29297 10.707L12 16.414L17.707 10.707L16.293 9.29297Z" :fill="dropdowns.model.length < 1 ? '#737373' : '#DE4527'"/>
            </svg>
        </div>


        <div class="sf__vehicles__option" data-label="Submodel" :class="{ 'option-selected': selections.submodel != '' }">
            <select v-bind:class="{ 'selected': selections.submodel != '', 'errored': selections.submodel == '' && showError }" name="submodel" id="" v-model="selections.submodel" :disabled="dropdowns.submodel.length < 1">
                <option value="">{{ submodelLabel || 'Select Submodel'}}</option>
                <option v-for="submodel in dropdowns.submodel" :key="submodel.key" :value="submodel.key">{{ submodel.value }}</option>
            </select>
            <svg class="sf__vehicles__select-icon" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false">
                <path d="M16.293 9.29297L12 13.586L7.70697 9.29297L6.29297 10.707L12 16.414L17.707 10.707L16.293 9.29297Z" :fill="dropdowns.submodel.length < 1 ? '#737373' : '#DE4527'"/>
            </svg>
        </div>

        <button
            type="button"
            @click.prevent.stop="search"
            @mouseenter="openPrimaryTooltip()"
            @mouseleave="closePrimaryTooltip()"
            @focus="openPrimaryTooltip()"
            @blur="closePrimaryTooltip()"
            :disabled="isProcessing"
            :aria-disabled="vehicleActionDisabled.toString()"
            :aria-describedby="vehicleActionDisabled ? primaryTooltipId : null"
            :class="{
                'sf__vehicles__button--loading': isProcessing,
                'sf__vehicles__button--primary': isModalFlow()
            }"
        >
            <span v-if="isProcessing" class="sf__vehicles__button-spinner" aria-hidden="true"></span>
            {{ buttonLabel }}
            <span
                v-if="primaryTooltipOpen && vehicleActionDisabled"
                :id="primaryTooltipId"
                class="sf__filters__primary-action-tooltip"
                role="tooltip"
            >
                Complete all selections to continue
            </span>
        </button>
    </div>
    <p v-if="showError" class="sf__vehicles__error">You need to select all of the options to continue.</p>
</template>

<script>
import {range} from 'lodash'; 
import Ecommerce from '../adapters/Ecommerce'; 
import Searcher from '../helpers/searcher'; 
import Pluralize from 'pluralize'; 
import {slugify} from '../helpers/helpers';
import storage from '../helpers/storage';

const Platform = Ecommerce.getInstance(window.sf_options.platform); 

export default {

    props: ['foam', 'videos', 'buttonText', 'yearLabel', 'makeLabel', 'modelLabel', 'submodelLabel', 'modalFlow', 'initialSelections', 'cantFindLabel', 'processing'],

    emits: ['vehicleSelected'],

    data() {
        return {
            started: false, 
            showError: false,
            dropdowns: {
                year: [], 
                make: [], 
                model: [],
                submodel: []
            },
            selections:{
                year: '', 
                make: '', 
                model: '',
                submodel: ''
            },
            searching: false,
            primaryTooltipOpen: false,
            primaryTooltipPinned: false
        }
    },

    computed: {
        can_continue() {
            return this.selections.year != '' && this.selections.make != '' && this.selections.model != '' && this.selections.submodel != '';
        },

        isProcessing() {
            return this.searching || this.processing === true || this.processing === 'true';
        },

        vehicleActionDisabled() {
            return this.isModalFlow() && !this.can_continue;
        },

        primaryTooltipId() {
            return 'sf-vehicles-primary-tooltip';
        },

        buttonLabel() {
            if (this.isProcessing) {
                return 'Loading';
            }

            return this.buttonText || 'View Products';
        }
    },


    watch: {
        'selections.year': function(newval) {
            if ( newval != '' && this.started) {
                this.pullDropdowns('make'); 
            }
        }, 

        'selections.make': function(newval) {
            if ( newval != '' && this.started) {
                this.pullDropdowns('model'); 
            }
        },

        'selections.model': function(newval) {
            if ( newval != '' && this.started) {
                this.pullDropdowns('submodel'); 
            }
        }, 

        'selections': {
            deep: true, 
            handler(newVal) {
                this.closePrimaryTooltip(true);

                if (!Object.values(this.selections).includes('') && this.showError ) {
                    this.showError = false; 
                }
            }
        },

        initialSelections: {
            deep: true,
            handler(newVal) {
                if (newVal) {
                    this.seedInitialSelections(newVal);
                }
            }
        }
    }, 


    async mounted() {
        if (this.initialSelections) {
            await this.seedInitialSelections(this.initialSelections);
            return;
        }

        const currentSelections = storage.getLastVehicleSelection(); 

        if (currentSelections) {
            this.dropdowns = {...currentSelections.dropdowns};
            this.$nextTick(() => {
                this.selections = {...currentSelections.selections};
                
                this.$nextTick(() => {
                    this.started = true; 
                });
            });
        } else {
            this.getYears(); 
            this.started = true; 
        }
    },

    methods: {
        openPrimaryTooltip(pinned = false) {
            if (this.vehicleActionDisabled) {
                this.primaryTooltipOpen = true;
                this.primaryTooltipPinned = pinned;
            }
        },

        closePrimaryTooltip(force = false) {
            if (this.primaryTooltipPinned && !force) {
                return;
            }

            this.primaryTooltipOpen = false;
            this.primaryTooltipPinned = false;
        },

        async seedInitialSelections(initialSelections) {
            this.started = false;
            this.showError = false;
            this.dropdowns = {
                year: [],
                make: [],
                model: [],
                submodel: []
            };
            this.selections = {
                year: '',
                make: '',
                model: '',
                submodel: ''
            };

            await this.getYears();

            if (initialSelections.year) {
                this.selections.year = initialSelections.year;
                await this.pullDropdowns('make');
            }

            if (initialSelections.make) {
                this.selections.make = initialSelections.make;
                await this.pullDropdowns('model');
            }

            if (initialSelections.model) {
                this.selections.model = initialSelections.model;
                await this.pullDropdowns('submodel');
            }

            if (initialSelections.submodel) {
                this.selections.submodel = initialSelections.submodel;
            }

            this.started = true;
        },

        async pullDropdowns(facet) {

            // First we null all n+1 options after the first empty. 
            let facetIndex = ['year', 'make', 'model', 'submodel'].findIndex( (key) => key == facet ); 

            // Emptying all n+1 selections and dropdowns. 
            ['year', 'make', 'model', 'submodel'].forEach((f, index) => {
                if ( index >= facetIndex) {
                    this.selections[f] = ''; 
                    this.dropdowns[f] = []; 
                }
            })

            let {facets} = await Searcher.search( this.isFoam() ? 'foam durofoam' : '*', {
                optionalWords: this.isFoam() ? 'foam durofoam' : null, 
                filters: Searcher.buildFilters( this.selections ),
                facets: [`vehicle.${facet}`], 
            });
            
            if (Object.keys(facets).length === 0 && facet == 'submodel') {
                this.dropdowns[facet] = [
                    {key: '', value: `All available ${Pluralize(facet)}` }
                ]
            } else {
                this.dropdowns[facet] = Object.keys(facets[`vehicle.${facet}`]).sort().map (val => {
                    return {key: val, value: val}
                });
            }

            return this.dropdowns[facet]; 
        }, 


        async getYears() {

            let {facets} = await Searcher.search( this.isFoam() ? 'foam durofoam' : '*', {
                optionalWords: this.isFoam() ? 'foam durofoam' : null, 
                facets: ['vehicle.start_year', 'vehicle.end_year']
            }); 

            let years = range(
                parseInt(Object.keys(facets['vehicle.start_year']).sort()[0]), 
                parseInt(Object.keys(facets['vehicle.end_year']).sort().reverse()[0]) + 1, // We add the +1 because the range method doesn't include the end value.  
            ); 

            this.dropdowns['year'] = years.map( year => {
                return { key: year, value: year }; 
            }); 

            return; 
        }, 


        async search() {
            if (this.isProcessing) {
                return;
            }

            if (!this.can_continue) {
                if (this.isModalFlow()) {
                    this.openPrimaryTooltip(true);
                } else {
                    this.showError = true;
                }

                if ( typeof window?.sf_options?.onYmmsError === 'function') {
                    window.sf_options.onYmmsError(); 
                }
                return; 
            } else {
                this.showError = false; 
            }

            if ( typeof window?.sf_options?.onYmmsSearch === 'function') {
                window.sf_options.onYmmsSearch(); 
            }

            this.searching = true;

            try {
                const searchParams = {
                    optionalWords: this.isFoam() ? 'foam durofoam' : null, 
                    filters: Searcher.buildFilters(this.selections)
                };

                if (this.isModalFlow()) {
                    searchParams.hitsPerPage = 2000;
                }

                let {hits} = await Searcher.search( this.isFoam() ? 'foam durofoam' : '*', searchParams);

                storage.storeLastVehicleSelection({
                    selections: this.selections, 
                    dropdowns: this.dropdowns
                }); 

                let params = { ...this.selections }; 

                const handle = slugify(
                    Object.values(params).join('-')
                );

                if (this.isVideos()) {
                    this.$emit('vehicleSelected', params); 
                    return;
                }

                if (this.isModalFlow()) {
                    this.$emit('vehicleSelected', {
                        params,
                        hits,
                        handle,
                        foam: this.isFoam()
                    });
                    return;
                }

                Platform.goToPartResults(handle, {
                    ...params, 
                    ...{ foam: this.isFoam() }
                }); 
            } finally {
                this.searching = false;
            }
        }, 



        isFoam() {
            if ( this.foam ) {
                return true; 
            }

            const urlParams = new URLSearchParams(window.location.search);
            return urlParams.get('foam') == 'true' ? true : false; 
        }, 

        isVideos() {
            if ( this.videos ) {
                return true; 
            }

            const urlParams = new URLSearchParams(window.location.search);
            return urlParams.get('videos') ? true : false; 
        },

        isModalFlow() {
            return this.modalFlow === true || this.modalFlow === 'true';
        },
    }
}

</script>
